import { Component } from '@angular/core';

@Component({
  selector: 'app-kidzee-partner-thankyou',
  templateUrl: './kidzee-partner-thankyou.component.html',
  styleUrls: ['./kidzee-partner-thankyou.component.css']
})
export class KidzeePartnerThankyouComponent {

}
